const FiltersListener = require('./generated/FiltersListener').FiltersListener;
var FiltersDSLGenerator = function () {
  FiltersListener.call(this);
  this.rootNode = null;
  this.nodeStack = [];
  this.level = 0;
  this.attrStack = [];
};

FiltersDSLGenerator.prototype = Object.create(FiltersListener.prototype);
FiltersDSLGenerator.prototype.constructor = FiltersDSLGenerator;

FiltersDSLGenerator.prototype.getFiltersDSLObject = function () {
  return this.rootNode;
};

// Enter a parse tree produced by FiltersParser#filters.
FiltersDSLGenerator.prototype.enterFilters = function (ctx) {
  let node = { type: 'filters', parameters: [] };
  this.level++;
  this.nodeStack.unshift(node);
};

// Exit a parse tree produced by FiltersParser#filters.
FiltersDSLGenerator.prototype.exitFilters = function (ctx) {
  let node = this.nodeStack.shift();
  this.level--;
  this.rootNode = node;
};

// Enter a parse tree produced by FiltersParser#bracketnotation.
FiltersDSLGenerator.prototype.enterBracketnotation = function (ctx) {};

// Exit a parse tree produced by FiltersParser#bracketnotation.
FiltersDSLGenerator.prototype.exitBracketnotation = function (ctx) {};

// Enter a parse tree produced by FiltersParser#bracketnotation_expr.
FiltersDSLGenerator.prototype.enterBracketnotation_expr = function (ctx) {};

// Exit a parse tree produced by FiltersParser#bracketnotation_expr.
FiltersDSLGenerator.prototype.exitBracketnotation_expr = function (ctx) {};

// Enter a parse tree produced by FiltersParser#queryGroup.
FiltersDSLGenerator.prototype.enterQueryGroup = function (ctx) {
  this.level++;

  let node = { type: 'filterGroup', parameters: [] };
  this.nodeStack.unshift(node);
};

// Exit a parse tree produced by FiltersParser#queryGroup.
FiltersDSLGenerator.prototype.exitQueryGroup = function (ctx) {
  this.level--;
  let node = this.nodeStack.shift();
  if (this.nodeStack.length > 0) {
    this.nodeStack[0].parameters.push(node);
  }
};

// Enter a parse tree produced by FiltersParser#groupJoinOp.
FiltersDSLGenerator.prototype.enterGroupJoinOp = function (ctx) {};

// Exit a parse tree produced by FiltersParser#groupJoinOp.
FiltersDSLGenerator.prototype.exitGroupJoinOp = function (ctx) {
  var op = ctx.getText();
  this.nodeStack[0].parameters.push({ type: 'groupJoinOp', value: op });
};

// Enter a parse tree produced by FiltersParser#queryExpr.
FiltersDSLGenerator.prototype.enterQueryExpr = function (ctx) {};

// Exit a parse tree produced by FiltersParser#queryExpr.
FiltersDSLGenerator.prototype.exitQueryExpr = function (ctx) {};

// Enter a parse tree produced by FiltersParser#queryRule.
FiltersDSLGenerator.prototype.enterQueryRule = function (ctx) {
  this.level++;

  var node = {
    type: 'filterRule',
    ruleAttr: {},
    ruleOp: null,
    ruleValue: null,
  };
  this.nodeStack.unshift(node);
};

// Exit a parse tree produced by FiltersParser#queryRule.
FiltersDSLGenerator.prototype.exitQueryRule = function (ctx) {
  this.level--;
  var node = this.nodeStack.shift();
  if (this.nodeStack.length > 0) {
    this.nodeStack[0].parameters.push(node);
  }
};

// Enter a parse tree produced by FiltersParser#atom.
FiltersDSLGenerator.prototype.enterAtom = function (ctx) {};

// Exit a parse tree produced by FiltersParser#atom.
FiltersDSLGenerator.prototype.exitAtom = function (ctx) {};

// Enter a parse tree produced by FiltersParser#pathRef.
FiltersDSLGenerator.prototype.enterPathRef = function (ctx) {
  this.level++;
  var node = { type: 'attributeRef', parameters: [] };
  this.nodeStack.unshift(node);
};

// Exit a parse tree produced by FiltersParser#pathRef.
FiltersDSLGenerator.prototype.exitPathRef = function (ctx) {
  this.level--;

  let pathRefNode = this.nodeStack.shift();
  let parentNode = this.nodeStack[0];
  if (parentNode.type === 'filterRule') {
    this.nodeStack[0].ruleAttr.attrParts = pathRefNode.parameters.map((i) => i.value);
  } else {
    this.nodeStack[0].parameters.push(pathRefNode);
  }
};

// Enter a parse tree produced by FiltersParser#attrpart.
FiltersDSLGenerator.prototype.enterAttrpart = function (ctx) {};

// Exit a parse tree produced by FiltersParser#attrpart.
FiltersDSLGenerator.prototype.exitAttrpart = function (ctx) {
  let ctxStringText = ctx.string() !== null ? ctx.string().getText() : '';
  if (ctxStringText.length > 1) {
    ctxStringText = ctxStringText.substring(1, ctxStringText.length - 1);
  }
  this.nodeStack[0].parameters.push({ type: 'attrPart', value: ctxStringText });
};

// Enter a parse tree produced by FiltersParser#regexBegin.
FiltersDSLGenerator.prototype.enterRegexBegin = function (ctx) {
  this.level++;
  var node = { type: 'regexBegin', parameters: [] };
  this.nodeStack.unshift(node);
};

// Exit a parse tree produced by FiltersParser#regexBegin.
FiltersDSLGenerator.prototype.exitRegexBegin = function (ctx) {
  this.level--;
  var node = this.nodeStack.shift();
  let parentNode = this.nodeStack[0];
  if (parentNode.type === 'filterRule') {
    this.nodeStack[0].ruleValue = node;
  } else {
    this.nodeStack[0].parameters.push(node);
  }
};

// Enter a parse tree produced by FiltersParser#regexContains.
FiltersDSLGenerator.prototype.enterRegexContains = function (ctx) {
  this.level++;
  var node = { type: 'regexContains', parameters: [] };
  this.nodeStack.unshift(node);
};

// Exit a parse tree produced by FiltersParser#regexContains.
FiltersDSLGenerator.prototype.exitRegexContains = function (ctx) {
  this.level--;
  var node = this.nodeStack.shift();
  let parentNode = this.nodeStack[0];
  if (parentNode.type === 'filterRule') {
    this.nodeStack[0].ruleValue = node;
  } else {
    this.nodeStack[0].parameters.push(node);
  }
};

// Enter a parse tree produced by FiltersParser#regexEnd.
FiltersDSLGenerator.prototype.enterRegexEnd = function (ctx) {
  this.level++;
  var node = { type: 'regexEnd', parameters: [] };
  this.nodeStack.unshift(node);
};

// Exit a parse tree produced by FiltersParser#regexEnd.
FiltersDSLGenerator.prototype.exitRegexEnd = function (ctx) {
  this.level--;
  var node = this.nodeStack.shift();
  let parentNode = this.nodeStack[0];
  if (parentNode.type === 'filterRule') {
    this.nodeStack[0].ruleValue = node;
  } else {
    this.nodeStack[0].parameters.push(node);
  }
};

// Enter a parse tree produced by FiltersParser#joinOp.
FiltersDSLGenerator.prototype.enterJoinOp = function (ctx) {};

// Exit a parse tree produced by FiltersParser#joinOp.
FiltersDSLGenerator.prototype.exitJoinOp = function (ctx) {
  var op = ctx.getText();
  this.nodeStack[0].parameters.push({ type: 'ruleJoinOp', value: op });
};

// Enter a parse tree produced by FiltersParser#caseParam.
FiltersDSLGenerator.prototype.enterCaseParam = function (ctx) {};

// Exit a parse tree produced by FiltersParser#caseParam.
FiltersDSLGenerator.prototype.exitCaseParam = function (ctx) {
  this.nodeStack[0].parameters.push({
    type: 'caseParam',
    value: ctx.getText() === '(?i)' ? false : true,
  });
};

// Enter a parse tree produced by FiltersParser#filterOp.
FiltersDSLGenerator.prototype.enterFilterOp = function (ctx) {};

// Exit a parse tree produced by FiltersParser#filterOp.
FiltersDSLGenerator.prototype.exitFilterOp = function (ctx) {
  var op = ctx.getText();
  let parentNode = this.nodeStack[0];
  if (parentNode.type === 'filterRule') {
    this.nodeStack[0].ruleOp = op;
  } else {
    this.nodeStack[0].parameters.push({ type: 'ruleOp', value: op });
  }
};

// Enter a parse tree produced by FiltersParser#nullValue.
FiltersDSLGenerator.prototype.enterNullValue = function (ctx) {};

// Exit a parse tree produced by FiltersParser#nullValue.
FiltersDSLGenerator.prototype.exitNullValue = function (ctx) {
  let parentNode = this.nodeStack[0];
  if (parentNode.type === 'filterRule') {
    this.nodeStack[0].ruleValue = { type: 'nullValue', value: null };
  } else {
    this.nodeStack[0].parameters.push({ type: 'nullValue', value: null });
  }
};

// Enter a parse tree produced by FiltersParser#boolValue.
FiltersDSLGenerator.prototype.enterBoolValue = function (ctx) {};

// Exit a parse tree produced by FiltersParser#boolValue.
FiltersDSLGenerator.prototype.exitBoolValue = function (ctx) {
  let param = {
    type: 'boolValue',
    value: ctx.getText() === 'true',
  };

  let parentNode = this.nodeStack[0];
  if (parentNode.type === 'filterRule') {
    this.nodeStack[0].ruleValue = param;
  } else {
    this.nodeStack[0].parameters.push(param);
  }
};

// Enter a parse tree produced by FiltersParser#regexValue.
FiltersDSLGenerator.prototype.enterRegexValue = function (ctx) {};

// Exit a parse tree produced by FiltersParser#regexValue.
FiltersDSLGenerator.prototype.exitRegexValue = function (ctx) {
  let ctxStringText = ctx.getText() !== null ? ctx.getText() : '';
  // if (ctxStringText.length > 1) {
  //   ctxStringText = ctxStringText.substring(1, ctxStringText.length - 1);
  // }
  let param = { type: 'string', value: ctxStringText };
  this.nodeStack[0].parameters.push(param);
};

// Enter a parse tree produced by FiltersParser#string.
FiltersDSLGenerator.prototype.enterString = function (ctx) {};

// Exit a parse tree produced by FiltersParser#string.
FiltersDSLGenerator.prototype.exitString = function (ctx) {
  let ctxStringText = ctx.getText() !== null ? ctx.getText() : '';
  if (ctxStringText.length > 1) {
    ctxStringText = ctxStringText.substring(1, ctxStringText.length - 1);
  }
  let param = { type: 'string', value: ctxStringText };

  let parentNode = this.nodeStack[0];

  if (parentNode.type === 'attributeRef') {
  } else if (parentNode.type === 'filterRule') {
    this.nodeStack[0].ruleValue = param;
  } else {
    this.nodeStack[0].parameters.push(param);
  }
};

// Enter a parse tree produced by FiltersParser#literal.
FiltersDSLGenerator.prototype.enterLiteral = function (ctx) {};

// Exit a parse tree produced by FiltersParser#literal.
FiltersDSLGenerator.prototype.exitLiteral = function (ctx) {};

// Enter a parse tree produced by FiltersParser#number.
FiltersDSLGenerator.prototype.enterNumber = function (ctx) {};

// Exit a parse tree produced by FiltersParser#number.
FiltersDSLGenerator.prototype.exitNumber = function (ctx) {
  let num = parseFloat(ctx.getText());
  let param = { type: 'number', value: num };
  let parentNode = this.nodeStack[0];

  if (parentNode.type === 'attributeRef') {
  } else if (parentNode.type === 'filterRule') {
    this.nodeStack[0].ruleValue = param;
  } else {
    this.nodeStack[0].parameters.push(param);
  }
};

// Enter a parse tree produced by FiltersParser#variable.
FiltersDSLGenerator.prototype.enterVariable = function (ctx) {};

// Exit a parse tree produced by FiltersParser#variable.
FiltersDSLGenerator.prototype.exitVariable = function (ctx) {};

exports.FiltersDSLGenerator = FiltersDSLGenerator;
